var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetquote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#F2F5F9",
    stroke: "#E5EBF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 12.5H27.4998C27.7209 12.5 27.9328 12.5878 28.0891 12.7441C28.2454 12.9004 28.3332 13.1123 28.3332 13.3333V26.6667C28.3332 26.8877 28.2454 27.0996 28.0891 27.2559C27.9328 27.4122 27.7209 27.5 27.4998 27.5H12.4998C12.2788 27.5 12.0669 27.4122 11.9106 27.2559C11.7543 27.0996 11.6665 26.8877 11.6665 26.6667V13.3333C11.6665 13.1123 11.7543 12.9004 11.9106 12.7441C12.0669 12.5878 12.2788 12.5 12.4998 12.5V12.5ZM26.6665 16.0317L20.0598 21.9483L13.3332 16.0133V25.8333H26.6665V16.0317ZM13.759 14.1667L20.0507 19.7183L26.2515 14.1667H13.759Z",
    fill: "#003C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetquote);
export default __webpack_public_path__ + "static/media/getquote.bb19983994c9694d5c5ddfb44171f562.svg";
export { ForwardRef as ReactComponent };